import React from 'react'

import { PlantDTO } from 'api'

export interface ILocalApiPlantsContext {
 plants?: PlantDTO[]
}

export default React.createContext<ILocalApiPlantsContext>({})
